<template>
  <div class="container">
    <transition :name="transitionName" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Container',
  data () {
    return {
      transitionName: 'jump'
    }
  },
  watch: {
    '$route' (to, from) {
      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length

      console.log("to", to)
      console.log("from", from)

      if (toDepth > fromDepth) {
        this.transitionName = 'page-push'
      } else if (toDepth < fromDepth) {
        this.transitionName = 'page-pop'
      } else {
        this.transitionName = 'page-jump'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/Container.vue